'use strict';

var TopItemsModel = require('components/usageShared/TopItemsModel');

/**
 * Model/loader for top client usage data
 */
module.exports = TopItemsModel.extend({

  rpc: {
    read: [
      {
        method: 'DNA.Portal.Bandwidth.getTopClients',
        params: function() {
          return {
            mac: this.get('deviceMac'),
          };
        },
      },
    ],
  },

  getMacError: function() {
    return 'TopClientsModel: deviceMac must be set before fetching';
  },
});
